import script from "./AssetPositionDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./AssetPositionDialog.vue?vue&type=script&lang=ts&setup=true"

import "./AssetPositionDialog.vue?vue&type=style&index=0&id=bc865cd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc865cd0"]])

export default __exports__